// import React from 'react';
// import BreadCrumb from '../../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../../HospitalList/HospitalList.module.scss';

// const Page8 = () => {
//   return (
//     <>
//       <BreadCrumb name="Privacy Policy" />

//       <div className={classes.ViewHospital}>
//         <div className={classes.TableDiv}>
//           {/* <div className={classes.privacyPolicy}> */}
//             <h2 className={classes.boldHeading}>Privacy Policy</h2>

//             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
//               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>Introduction</h3>
//               <p className={classes.paragraphText}>
//                 GATI App is committed to protecting the privacy of our office employees ("users," "you"). 
//                 This Privacy Policy outlines how we collect, use, store, and protect your personal information 
//                 when you use our application for geo-location-based attendance marking and face recognition.
//               </p>
//             </section>

//             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
//               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>1. Information We Collect</h3>
//               <ul className={classes.styledList}>
//                 <li className={classes.listItem}><strong>Personal Identification Information:</strong> Name, email address, employee ID, department.</li>
//                 <li className={classes.listItem}><strong>Picture:</strong> Facial recognition data used for verifying attendance.</li>
//                 <li className={classes.listItem}><strong>Geo-Location Data:</strong> Real-time location information to mark attendance.</li>
//                 <li className={classes.listItem}><strong>Device Information:</strong> Information about the device you use to access the app, including device ID, operating system, and browser type.</li>
//                 <li className={classes.listItem}><strong>Usage Data:</strong> Information on how you interact with the app, such as features used and duration of use.</li>
//               </ul>
//             </section>

//             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
//               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>2. How We Use Your Information</h3>
//               <ul className={classes.styledList}>
//                 <li className={classes.listItem}><strong>Attendance Verification:</strong> To mark and verify your attendance using geo-location and face recognition data.</li>
//                 <li className={classes.listItem}><strong>To Provide and Improve Services:</strong> Ensure the app functions correctly and improve its features.</li>
//                 <li className={classes.listItem}><strong>Communication:</strong> Send notifications, updates, and other relevant information related to your work.</li>
//                 <li className={classes.listItem}><strong>Support:</strong> Provide technical support and address any issues or inquiries.</li>
//                 <li className={classes.listItem}><strong>Compliance:</strong> Comply with legal obligations and company policies.</li>
//               </ul>
//             </section>

//             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
//               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>3. Data Sharing and Disclosure</h3>
//               <ul className={classes.styledList}>
//                 <li className={classes.listItem}><strong>Service Providers:</strong> We do not share any information with third-party service providers.</li>
//                 <li className={classes.listItem}><strong>Legal Requirements:</strong> If required by law, regulation, or legal process, we may disclose your information.</li>
//                 <li className={classes.listItem}><strong>Company Policies:</strong> To enforce our policies and comply with company regulations.</li>
//               </ul>
//             </section>

//             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
//               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>4. Data Security</h3>
//               <p className={classes.paragraphText}>
//                 We implement appropriate technical and organizational measures to protect your personal 
//                 information from unauthorized access, loss, or misuse. These measures include access controls 
//                 and regular security assessments.
//               </p>
//             </section>

//             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
//               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>5. Data Retention</h3>
//               <p className={classes.paragraphText}>
//                 We retain your personal information for as long as necessary to fulfill the purposes outlined 
//                 in this Privacy Policy or as required by law.
//               </p>
//             </section>

//             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
//               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>6. Your Rights</h3>
//               <ul className={classes.styledList}>
//                 <li className={classes.listItem}><strong>Access:</strong> Request access to your personal information we hold.</li>
//                 <li className={classes.listItem}><strong>Correction:</strong> Request correction of inaccurate or incomplete information.</li>
//                 <li className={classes.listItem}><strong>Deletion:</strong> Request deletion of your personal information, subject to legal and contractual obligations.</li>
//               </ul>
//             </section>

//             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
//               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>7. Changes to This Privacy Policy</h3>
//               <p className={classes.paragraphText}>
//                 We may update this Privacy Policy from time to time. Any changes will be posted on this page, 
//                 and we will notify you of significant changes through the app or email.
//               </p>
//             </section>

//             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
//               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>8. Contact Us</h3>
//               <p className={classes.paragraphText}>
//                 If you have any questions or concerns about this Privacy Policy, please contact us at 
//                 <a href="mailto:rapidx.rrts@ncrtc.in" className={classes.contactLink}>  rapidx.rrts@ncrtc.in</a>.
//               </p>
//             </section>
//           </div>
//         </div>
//       {/* </div> */}
//     </>
//   );
// };

// export default Page8;
















import React from 'react';
import BreadCrumb from '../../../utilities/BreadCrumb/BreadCrumb';
import classes from '../../HospitalList/HospitalList.module.scss';
import '../../HospitalList/HospitalList.module.scss';

const Page8 = () => {

  return (
    <>
      <BreadCrumb name="Privacy Policy" />
    
      <div className={classes.ViewHospital}>
         <div className={classes.TableDiv}>
           {/* <div className={classes.privacyPolicy}> */}
             <h2 className={classes.boldHeading}>Privacy Policy</h2>

             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>Introduction</h3>
               <p className={classes.paragraphText}>
                 GATI App is committed to protecting the privacy of our office employees ("users," "you"). 
                 This Privacy Policy outlines how we collect, use, store, and protect your personal information 
                 when you use our application for geo-location-based attendance marking and face recognition.
               </p>
             </section>

             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>1. Information We Collect</h3>
               <ul className={classes.styledList}>
                 <li className={classes.listItem}><strong>Personal Identification Information:</strong> Name, email address, employee ID, department.</li>
                 <li className={classes.listItem}><strong>Picture:</strong> Facial recognition data used for verifying attendance.</li>
                 <li className={classes.listItem}><strong>Geo-Location Data:</strong> Real-time location information to mark attendance.</li>
                 <li className={classes.listItem}><strong>Device Information:</strong> Information about the device you use to access the app, including device ID, operating system, and browser type.</li>
                 <li className={classes.listItem}><strong>Usage Data:</strong> Information on how you interact with the app, such as features used and duration of use.</li>
               </ul>
             </section>

             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>2. How We Use Your Information</h3>
               <ul className={classes.styledList}>
                 <li className={classes.listItem}><strong>Attendance Verification:</strong> To mark and verify your attendance using geo-location and face recognition data.</li>
                 <li className={classes.listItem}><strong>To Provide and Improve Services:</strong> Ensure the app functions correctly and improve its features.</li>
                 <li className={classes.listItem}><strong>Communication:</strong> Send notifications, updates, and other relevant information related to your work.</li>
                 <li className={classes.listItem}><strong>Support:</strong> Provide technical support and address any issues or inquiries.</li>
                 <li className={classes.listItem}><strong>Compliance:</strong> Comply with legal obligations and company policies.</li>
               </ul>
             </section>

             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>3. Data Sharing and Disclosure</h3>
               <ul className={classes.styledList}>
                 <li className={classes.listItem}><strong>Service Providers:</strong> We do not share any information with third-party service providers.</li>
                 <li className={classes.listItem}><strong>Legal Requirements:</strong> If required by law, regulation, or legal process, we may disclose your information.</li>
                 <li className={classes.listItem}><strong>Company Policies:</strong> To enforce our policies and comply with company regulations.</li>
               </ul>
             </section>

             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>4. Data Security</h3>
               <p className={classes.paragraphText}>
                 We implement appropriate technical and organizational measures to protect your personal 
                 information from unauthorized access, loss, or misuse. These measures include access controls 
                 and regular security assessments.
               </p>
             </section>

             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>5. Data Retention</h3>
               <p className={classes.paragraphText}>
                 We retain your personal information for as long as necessary to fulfill the purposes outlined 
                 in this Privacy Policy or as required by law.
               </p>
             </section>

             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>6. Your Rights</h3>
               <ul className={classes.styledList}>
                 <li className={classes.listItem}><strong>Access:</strong> Request access to your personal information we hold.</li>
                 <li className={classes.listItem}><strong>Correction:</strong> Request correction of inaccurate or incomplete information.</li>
                 <li className={classes.listItem}><strong>Deletion:</strong> Request deletion of your personal information, subject to legal and contractual obligations.</li>
               </ul>
             </section>

             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>7. Changes to This Privacy Policy</h3>
               <p className={classes.paragraphText}>
                 We may update this Privacy Policy from time to time. Any changes will be posted on this page, 
                 and we will notify you of significant changes through the app or email.
               </p>
             </section>

             <section className={`${classes.sectionContent} ${classes.sectionWithBorder}`}>
               <h3 className={`${classes.sectionHeading} ${classes.colorfulHeading}`}>8. Contact Us</h3>
               <p className={classes.paragraphText}>
                 If you have any questions or concerns about this Privacy Policy, please contact us at 
                 <a href="mailto:rapidx.rrts@ncrtc.in" className={classes.contactLink}>  rapidx.rrts@ncrtc.in</a>.
               </p>
             </section>
           </div>
         </div>
    </>
  );
};
export default Page8;